import LocalStorage from '@/service/LocalStorage';

export const setAccessToken = (token: string) => {
  LocalStorage.set('token', token);
};

export const getAccessToken = ({
  withLocalStorage = false,
  withUrl = false,
}: { withLocalStorage?: boolean; withUrl?: boolean } = {}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');

  if (withLocalStorage) {
    return LocalStorage.get<string>('token');
  } else if (withUrl) {
    return urlToken;
  } else {
    return LocalStorage.get<string>('token') ?? urlToken;
  }
};
